import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AuthService } from '../auth/auth.service';
import { GetSiteGQL } from '../graphql/graphql';

@Component({
    selector: 'app-site-manage',
    templateUrl: './site-manage.component.html',
    styleUrls: ['./site-manage.component.scss'],
    standalone: false
})
export class SiteManageComponent implements OnInit {
    siteName: string = '';
    siteLogo: string = '';

    constructor(
        public auth: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private getSiteGQL: GetSiteGQL,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        const url = this.route.snapshot.params['url'] || '';
        if (url) {
            this.getSiteGQL.watch({ variables: { url, categoryId: '' } }).valueChanges.subscribe(result => {
                this.siteName = result.data?.site?.client?.name || '';
                this.siteLogo = result.data?.site?.client?.logo?.src || '';
            });
        }
    }

    isSvgMarkup(value: string): boolean {
        return value?.trim().startsWith('<');
    }

    sanitizeSvg(value: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }

    logout() {
        this.auth.logout();
        this.router.navigate(['/login']);
    }
}
